import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { UserContext } from "../../App";
import { getToken } from "../UpdateUsersState";

const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { userData } = useContext(UserContext);

  useEffect(() => {
    const token = getToken();
    if (token && userData?.permissions.length > 0 && userData?.permissions.includes("monitoring")) {
      const socketInstance = io(process.env.REACT_APP_SOCKET_URL, {
        transports: ["websocket"],
        query: { token },
      });

      socketInstance.on("connect", () => {
        console.log("Connected:", socketInstance.id);
      });

      socketInstance.on("connect_error", (err) => {
        console.log("Connection Error:", err.message);
      });

      socketInstance.on("disconnect", () => {
        console.log("Disconnected");
      });

      setSocket(socketInstance);
      return () => {
        socketInstance.disconnect();
        setSocket(null);
      };
    } else {
      console.log("Data or token not found")
      setSocket(null);
    }
    // eslint-disable-next-line
  }, [userData]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};
